import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { useParams } from "react-router-dom";
import { auth } from "../../../../../firebase.init";
import useSingleProduct from "../../../../../hooks/useSingleProduct";
import "./SingPageDetails.css";

const SingPageDetails = () => {
  // Product Info
  const { id } = useParams();
  const [viewProduct, setViewProduct] = useSingleProduct(id);
  // Check User
  const [user] = useAuthState(auth);

  //  quantity handle
  const quantity = document.getElementById("product-quantity");
  const updateSubmit = document.getElementById("update-submit");
  const [domQuantity, setDomQuantity] = useState();


  const handleQuantitySubmit = (event) => {
    event.preventDefault();
    const quantityEditBtn = document.getElementById("quantity-edit-btn");
    quantityEditBtn.style.display = "inline";
    quantity.setAttribute("disabled", "");
    updateSubmit.style.display = "none";
    const newQuantity=(event.target.productQuantity.value);


    // update Request
    const url=`https://rocky-ravine-79485.herokuapp.com/product/edit-q/${id}?quantity=${newQuantity}`
    axios.put(url,{
      productQuantity:newQuantity
    }).then(res=>console.log(res))
  };

  const handleClickQuantity = (e) => {
    quantity.removeAttribute("disabled");
    updateSubmit.style.display = "block";
    e.target.style.display = "none";
  };
  const handleChangeQuantityValue=e=>{
    setDomQuantity(e.target.value)
    console.log(domQuantity);
  }

  useEffect(() => {
    setDomQuantity(viewProduct?.data?.productQuantity);
  }, [viewProduct]);

 
  return (
    <div>
      <Container>
        <Row className="my-5">
          <Col md={5} className="">
            <img
              className="img-fluid"
              style={{}}
              src={viewProduct?.data?.photoURL}
              alt=""
            />
          </Col>
          <Col md={6}>
            <h4>{viewProduct?.data?.productName}</h4>
            <p>
              Price:
              <span className="fw-semibold">
                {" "}
                $ {viewProduct?.data?.productPrice}
              </span>{" "}
            </p>

            <Form onSubmit={handleQuantitySubmit}>
              <Row className="align-items-end">
                <Form.Group as={Col} md="5">
                  <InputGroup>
                    <InputGroup.Text>Quantity</InputGroup.Text>
                    <Form.Control
                      id="product-quantity"
                      name="productQuantity"
                      type="number"
                      value={domQuantity}
                      onChange={handleChangeQuantityValue}
                      disabled
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group as={Col} md="6" className="">
                  {user ? (
                    <span
                      className="btn btn-info "
                      id="quantity-edit-btn"
                      onClick={handleClickQuantity}
                    >
                      <svg
                        style={{
                          display: "inline-block",
                          marginLeft: "10px",
                        }}
                        width={25}
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                      Edit Quantity
                    </span>
                  ) : (
                    ""
                  )}
                  <input
                    className="btn btn-success"
                    style={{ display: "none" }}
                    id="update-submit"
                    type="submit"
                    value="update"
                  />
                </Form.Group>
              </Row>
            </Form>

            <hr className="my-3" />
            <h5>Description</h5>
            <p className="fs-6">{viewProduct?.data?.productDescription}</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SingPageDetails;
